import React from 'react'
import img3 from '../../img/img3.jpg'
import '../Projects.css';


function Project3() {

    return (
        <>


            <div className='container-projects'>
                <img src={img3} />
                <div className='project-description'>
                    <h2 className='titulo-projects'>Renovation </h2>
                    The renovation of the staircase ornaments in the "Casa de los Pérez" was undertaken with the goal of revitalizing and modernizing the decorative details of this central area of the home. This project involved updating ornamental elements, including railings, handrails, and moldings, with a focus on improving the aesthetics, functionality, and safety of the staircase.<br></br><br></br>

                    <h1>Renovation Details:</h1>
                    <h1>Initial Evaluation and Planning:</h1><br></br>
                    Technical Inspection: A thorough evaluation of the existing ornaments was conducted to identify wear and tear, damage, and potential safety hazards. Specifically, the railings, handrails, and decorative moldings were assessed.<br></br><br></br>
                    Design and Planning: In collaboration with the homeowners, several designs were developed that combined traditional elements with modern touches. Different material and finish options were presented to ensure the homeowners' satisfaction and harmony with the rest of the home.
                </div>
            </div>
        </>
    )



}

export default Project3